import React, {useState, useEffect, useMemo} from 'react';
import {
    useMaterialReactTable,
    MaterialReactTable,
} from 'material-react-table';
import {Box, Typography, Link} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import apiService from '../../services/apiService';

const RewardsPage = () => {
    const [rewards, setRewards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        apiService.get('/api/rewards')
            .then(data => setRewards(data))
            .catch(err => setError(err.message || 'Failed to fetch rewards'))
            .finally(() => setLoading(false));
    }, []);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'ID',
                size: 20,
                Cell: ({cell}) => (
                    <Link component={RouterLink} to={`/rewards/${cell.getValue()}`}>
                        {cell.getValue()}
                    </Link>
                ),
            },
            {
                accessorKey: 'iconUrl',
                header: 'Icon',
                size: 60,
                Cell: ({cell, row}) => (
                    <Box
                        component="img"
                        src={cell.getValue()}
                        alt={row.original.name}
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            objectFit: 'cover',
                        }}
                    />
                ),
            },
            {
                accessorKey: 'identifier',
                header: 'Identifier',
                size: 80,
            },
            {
                accessorKey: 'name',
                header: 'Name',
                size: 120,
            },
            {
                accessorKey: 'estimatedValue',
                header: 'Est. Value',
                size: 100,
            },
            {
                accessorKey: 'sortOrder',
                header: 'Sort Order',
                size: 40,
            },
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data: rewards,
        enablePagination: false,
        enableBottomToolbar: false,
        state: {
            isLoading: loading,
            showAlertBanner: !!error,
        },
        muiToolbarAlertBannerProps: error
            ? {color: 'error', children: `Error: ${error}`}
            : undefined,
        initialState: {
            showGlobalFilter: true,
            sorting: [{id: 'sortOrder', desc: false}], // Default sort by sortOrder
        },
    });

    return (
        <Box sx={{p: 2}}>
            <Typography variant="h4" gutterBottom>
                Rewards
            </Typography>
            <MaterialReactTable table={table}/>
        </Box>
    );
};

export default RewardsPage;